import spartaEventsUtility from '@sparta.global.utilities/sparta-events-utility/dist/es6.js';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import SpartaTabNavUtility from '@sparta.global.utilities/sparta-tab-nav-utility/dist/es6.js';
import _ from '@sparta.global.vendors/lodash';
import creditCardUtility from '@sparta.credit-cards.utilities/credit-card-utility/dist/es6.js';
import htmlEscaper$1, { learnMoreUrl, termsAndConditions, applyNow, htmlEscaper } from '@sparta.credit-cards.helpers/credit-cards/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import { tabNavigation } from '@sparta.global.helpers/tab-navigation-helper/dist/es6.js';
import { json } from '@sparta.global.helpers/json-helper/dist/es6.js';

const Template$1 = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n\r\n<div class=\"campaign-properties-section spa-sticky\" data-sticky-level=\"2\" data-sticky-full-width=\"true\">\r\n</div>\r\n\r\n<div id=\"product-sticky-default\" data-jcr=\""
    + container.escapeExpression((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"data1") : depth0),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":11,"column":43},"end":{"line":11,"column":57}}}))
    + "\"></div>\r\n";
},"useData":true});
const renderTemplate$1 = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template$1(data, options);
};

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"sticky-nav-container\">\r\n  <div class=\"row collapse navbar show-for-medium-up navbar-row\">\r\n    <div class=\"column medium-7 navbar__nav-section\">\r\n      "
    + container.escapeExpression((lookupProperty(helpers,"tabNavigation")||(depth0 && lookupProperty(depth0,"tabNavigation"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"partials") : depth0),((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"tabNav") : stack1),{"name":"tabNavigation","hash":{},"data":data,"loc":{"start":{"line":7,"column":6},"end":{"line":7,"column":47}}}))
    + "\r\n    </div>\r\n    <div class=\"column medium-5 navbar__apply-section\">\r\n      <div class=\"slide-in-container\">\r\n        "
    + ((stack1 = (lookupProperty(helpers,"applyNow")||(depth0 && lookupProperty(depth0,"applyNow"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"applyNowMediumUp") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"params") : depth0)) != null ? lookupProperty(stack1,"requesttype") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1),(depth0 != null ? lookupProperty(depth0,"site") : depth0),(depth0 != null ? lookupProperty(depth0,"sparta") : depth0),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0)) != null ? lookupProperty(stack1,"BYAPAGE_ENABLE") : stack1),null,"",((stack1 = (depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0)) != null ? lookupProperty(stack1,"USA_ENABLE") : stack1),{"name":"applyNow","hash":{},"data":data,"loc":{"start":{"line":11,"column":8},"end":{"line":11,"column":168}}})) != null ? stack1 : "")
    + "\r\n        "
    + ((stack1 = (lookupProperty(helpers,"termsAndConditions")||(depth0 && lookupProperty(depth0,"termsAndConditions"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"termsAndConditions") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1),(depth0 != null ? lookupProperty(depth0,"site") : depth0),(depth0 != null ? lookupProperty(depth0,"sparta") : depth0),{"name":"termsAndConditions","hash":{},"data":data,"loc":{"start":{"line":12,"column":8},"end":{"line":12,"column":89}}})) != null ? stack1 : "")
    + "\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"row hide-for-medium-up\">\r\n    <div class=\"small-6 column\">\r\n      "
    + ((stack1 = (lookupProperty(helpers,"applyNow")||(depth0 && lookupProperty(depth0,"applyNow"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"applyNowSmall") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"params") : depth0)) != null ? lookupProperty(stack1,"requesttype") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1),(depth0 != null ? lookupProperty(depth0,"site") : depth0),(depth0 != null ? lookupProperty(depth0,"sparta") : depth0),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0)) != null ? lookupProperty(stack1,"BYAPAGE_ENABLE") : stack1),null,"",((stack1 = (depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0)) != null ? lookupProperty(stack1,"USA_ENABLE") : stack1),{"name":"applyNow","hash":{},"data":data,"loc":{"start":{"line":18,"column":6},"end":{"line":18,"column":163}}})) != null ? stack1 : "")
    + "\r\n    </div>\r\n    <div class=\"small-6 column\">\r\n      "
    + ((stack1 = (lookupProperty(helpers,"termsAndConditions")||(depth0 && lookupProperty(depth0,"termsAndConditions"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"termsAndConditionsSmall") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1),(depth0 != null ? lookupProperty(depth0,"site") : depth0),(depth0 != null ? lookupProperty(depth0,"sparta") : depth0),{"name":"termsAndConditions","hash":{},"data":data,"loc":{"start":{"line":21,"column":6},"end":{"line":21,"column":92}}})) != null ? stack1 : "")
    + "\r\n    </div>\r\n  </div>\r\n</div>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " \r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":0},"end":{"line":25,"column":7}}})) != null ? stack1 : "");
},"useData":true});
const renderTemplate = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.credit-cards.modules/product-sticky-navbar-cc-module",
  "version": "5.0.4",
  "id": "productStickyNavbarCcModule",
  "containerID": "creditCardsProductStickyNavbarCcModule",
  "moduleName": "credit-cards-product-sticky-navbar-cc-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "product-sticky-navbar-cc-module",
  "data": {
    "init": "productStickyNavbarCcModuleJS",
    "options": {}
  },
  "moduleParams": [{
    "name": "requesttype",
    "values": ["C", "BCC"],
    "default": "C",
    "description": "Consumer or Small Business Request Type"
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate$1(context, {
      "helpers": {
        tabNavigation,
        json,
        learnMoreUrl,
        termsAndConditions,
        applyNow,
        htmlEscaper
      },
      "partials": {
        "product-sticky-navbar-cc-partial": renderTemplate
      }
    });
  },
  "template": renderTemplate$1,
  "partials": {
    "product-sticky-navbar-cc-partial": renderTemplate
  },
  "helpers": {
    tabNavigation,
    json,
    learnMoreUrl,
    termsAndConditions,
    applyNow,
    htmlEscaper
  },
  "dependencies": {
    "@sparta.credit-cards.utilities/credit-card-utility": "^3.0.0",
    "@sparta.global.helpers/json-helper": "^1.0.0",
    "@sparta.global.helpers/tab-navigation-helper": "^1.0.0",
    "@sparta.credit-cards.helpers/credit-cards": "^3.0.0",
    "@sparta.global.utilities/sparta-events-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-sticky-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-tab-nav-utility": "^1.0.0",
    "@sparta.global.vendors/lodash": "^4.17.21"
  },
  "stores": []
};

/* global sparta spaParams */

/**
 * product-sticky-navbar-cc-module
 * module_js_id: productStickyNavbarCcModuleJS
 *
 * Copyright (c) 2017-12-4
 */

const EVENTS = {
  ELEMENT_UNSTICK: 'UNSTICK.spartaStickyUtility',
  ELEMENT_STICK: 'STICK.spartaStickyUtility'
};

/**
 * @class productStickyNavbarCcModuleJS
 * @extends Module
 */
class productStickyNavbarCcModuleJS extends Module {
  /**
   * Creates an instance of productStickyNavbarCcModuleJS.
   * @param {*} options Module options
   * @param {*} context Module context
   * @memberof productStickyNavbarCcModuleJS
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    const {
      target
    } = this.settings;
    this.content = JSON.parse(target.querySelector('#product-sticky-default').dataset.jcr);
    this.templatePartial = _moduleConfig.partials['product-sticky-navbar-cc-partial'];
    this.stickyTitleModuleEl = target.querySelector('.campaign-properties-section');
    this.activeId = '';
  }

  /**
   * Initialize the module
   * @returns {void}
   */
  init() {
    let campaignProperties;
    const {
      target
    } = this.settings;
    this.Events.sub('campaignProperties-spartaStore', data => {
      campaignProperties = data.data.data;
      const campaign = this.Store.getData('campaign');
      campaign.ID = creditCardUtility.buildCampaignString(campaign);
      const linkContent = creditCardUtility.generateLinkContent(this.content, campaignProperties);

      // Remove tabs that shouldn't be displayed
      linkContent.tabNav.tabs = linkContent.tabNav.tabs.filter(tab => {
        const isRewardsTab = tab.id === 'tabRewards' && !tab.earnToken && !tab.redeemToken;
        const isNetworkBenefitsTab = tab.id === 'tabNetworkBenefits' && tab.enableNetworkBenefits !== 'YES';
        if (isRewardsTab || isNetworkBenefitsTab) {
          return false;
        }
        return true;
      });
      const renderedTemplate = this.templatePartial({
        campaignProperties,
        campaign,
        content: linkContent,
        site: spaParams.siteParams,
        params: this.params,
        sparta
      }, {
        helpers: {
          htmlEscaper: htmlEscaper$1
        }
      });
      this.stickyTitleModuleEl.innerHTML = renderedTemplate;
      SpartaTabNavUtility.init();
      this.bindStickyEvents();
      this.bindScrollSpyEvents();
      creditCardUtility.delegateEvent('click', '.spa-boa-tnc-window', creditCardUtility.handleTermsLink.bind(this), false, target);
      this.Events.pub(creditCardUtility.EVENTS.productDetailsRendered, {
        module: this.settings.moduleInfo.name
      });

      // ADA fix for HTML in tab-nav aria attribute
      const tabsWithHtmlInAria = target.querySelectorAll('a[aria-label*="†"]');

      // Find tabs that have dagger HTML in the aria label and remove it.
      if (tabsWithHtmlInAria && tabsWithHtmlInAria.length > 0) {
        tabsWithHtmlInAria.forEach(tab => {
          const label = tab.getAttribute('aria-label');
          const startIdx = label.indexOf('<sup');
          const endIdx = label.indexOf('</sup>');
          if (startIdx > 0 && endIdx > 0) {
            tab.setAttribute('aria-label', `${label.substring(0, startIdx)}${label.substring(endIdx + 6)}`);
          }
        });
      }
    });
  }

  /**
   * Bind event handlers for events emitted by sticky utility
   *
   * @returns {void}
   */
  bindStickyEvents() {
    const slideContainer = document.querySelector('.slide-in-container');
    const links = document.querySelectorAll('.slide-in-container a');

    // Sticky utility doesn't pub an event on init, need to manually check on load.
    if (this.stickyTitleModuleEl.classList.contains('active')) {
      slideContainer.classList.add('shown');
    }
    spartaEventsUtility.sub(EVENTS.ELEMENT_STICK, ({
      data
    }) => {
      if (data === this.stickyTitleModuleEl) {
        if (slideContainer) slideContainer.classList.add('shown');
        Array.from(links).forEach(l => {
          l.setAttribute('tabindex', '0');
        });
      }
    });
    spartaEventsUtility.sub(EVENTS.ELEMENT_UNSTICK, ({
      data
    }) => {
      if (data === this.stickyTitleModuleEl) {
        if (slideContainer) slideContainer.classList.remove('shown');
        Array.from(links).forEach(l => {
          l.setAttribute('tabindex', '-1');
        });
      }
    });
  }

  /**
   * Bind scroll spy to product sections
   *
   * @returns {undefined}
   */
  bindScrollSpyEvents() {
    const {
      target
    } = this.settings;
    const tabs = Array.from(target.querySelectorAll('.spa-tab__tab-element'));
    tabs.forEach(tab => {
      const {
        href,
        id
      } = tab;
      const targetId = href.substring(href.indexOf('#') + 1);
      const targetEl = document.getElementById(targetId);

      // Check if tab has a target on the page, hide the tab if not present
      if (!targetEl) {
        // eslint-disable-next-line
        tab.style.display = 'none';
      }

      // Check to see if product section collides with sticky bar to set active state
      window.addEventListener('scroll', _.debounce(() => {
        if (this.stickyTitleModuleEl && targetEl && Array.from(this.stickyTitleModuleEl.classList).includes('active') && this.isCollision(targetEl, this.stickyTitleModuleEl) && this.activeId !== id) {
          /*
            The Sparta Tab Nav Utility's openPanel method signature takes an optional
            six parameters. We need to set the sixth param (focusTab boolean) to false.
            The first parameter, if its an ID, will override the next four
          */
          SpartaTabNavUtility.openPanel(id, undefined, undefined, undefined, undefined, false);
          this.activeId = id;
        }
      }));
    });

    // Remove active class when scrolling to top of the page
    window.addEventListener('scroll', _.debounce(() => {
      if (window.scrollY < 100) {
        tabs.forEach(tab => {
          tab.classList.remove('spa-tab__list-item-dropdown--active');
          tab.blur();
        });
        this.activeId = '';
      }
    }));
  }

  /**
   *
   * Y axis collision detection
   * @param {Node} el1 first element to detect
   * @param {Node} el2 second element to detect
   * @returns {Boolean} are the two elements colliding
   */
  isCollision(el1, el2) {
    let collision = false;
    const {
      top: el1Y,
      height: el1Height
    } = el1.getBoundingClientRect();
    const {
      top: el2Y,
      height: el2Height
    } = el2.getBoundingClientRect();
    if (el1Y < el2Y + el2Height && el1Height + el1Y > el2Y) {
      collision = true;
    }
    return collision;
  }
}
registerModuleClass({
  moduleClass: productStickyNavbarCcModuleJS,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { productStickyNavbarCcModuleJS as default, moduleConfig };
